import Collapse from "./Collapse";
export { Collapse as default, Collapse };
//# sourceMappingURL=index.js.map